/**
 * ATC button loading state — drawer-agnostic (Upcart, Rebuy, etc).
 * On pointerdown we ONLY toggle a class + fill a separate overlay. We never set
 * pointer-events:none on the button and never replace its inner HTML during the
 * press — either cancels the synthesized click on touch and breaks add-to-cart.
 */
(function() {
  'use strict';

  var SPINNER_SVG = '<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12 L10 18 L20 6" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var ATC_SELECTOR = '.product-form__submit';
  var EXCLUDE_SELECTOR = '#bundle-sticky_add_to_cart, .Vtl-StickyAddToCart, .sticky-product-details, #product-form-installment, #product-installment-form';

  var activeButton = null;
  var fallbackTimer = null;
  var successTimer = null;
  var addConfirmed = false;

  var originalFetch = window.fetch;
  if (originalFetch && !window.__atcFetchPatched) {
    window.__atcFetchPatched = true;
    window.fetch = function() {
      var args = arguments;
      var url = '';
      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) { url = ''; }
      var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var promise = originalFetch.apply(this, args);
      if (isCartAdd) {
        promise.then(function(response) {
          if (response && response.ok) document.dispatchEvent(new CustomEvent('atc:cart-added'));
          else document.dispatchEvent(new CustomEvent('atc:cart-error'));
        }).catch(function() {
          document.dispatchEvent(new CustomEvent('atc:cart-error'));
        });
      }
      return promise;
    };
  }

  function ensureOverlay(button) {
    var ov = button.querySelector(':scope > .atc-overlay');
    if (ov) return ov;
    ov = document.createElement('span');
    ov.className = 'atc-overlay';
    ov.setAttribute('aria-hidden', 'true');
    ov.innerHTML = '<span class="atc-overlay__icon"></span><span class="atc-overlay__label"></span>';
    button.appendChild(ov);
    return ov;
  }

  function setState(button, state) {
    var ov = ensureOverlay(button);
    var icon = ov.querySelector('.atc-overlay__icon');
    var label = ov.querySelector('.atc-overlay__label');
    if (state === 'adding') {
      icon.innerHTML = SPINNER_SVG;
      label.textContent = 'Adding…';
      button.classList.add('is-atc-adding');
      button.classList.remove('is-atc-added');
    } else if (state === 'added') {
      icon.innerHTML = CHECK_SVG;
      label.textContent = 'Added';
      button.classList.remove('is-atc-adding');
      button.classList.add('is-atc-added');
    }
  }

  function resetButton(button) {
    if (!button) return;
    button.classList.remove('is-atc-adding', 'is-atc-added');
  }

  function startAdding(e) {
    var button = e.target.closest(ATC_SELECTOR);
    if (!button) return;
    if (button.closest(EXCLUDE_SELECTOR)) return;
    if (button.disabled) return;
    if (button.classList.contains('is-atc-adding') || button.classList.contains('is-atc-added')) return;

    activeButton = button;
    addConfirmed = false;
    setState(button, 'adding');

    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function() {
      if (activeButton && !addConfirmed) { resetButton(activeButton); activeButton = null; }
    }, 8000);
  }

  document.addEventListener('pointerdown', startAdding, true);
  document.addEventListener('click', startAdding, true);

  document.addEventListener('pointercancel', function() {
    if (activeButton && !addConfirmed && !activeButton.classList.contains('is-atc-added')) {
      clearTimeout(fallbackTimer);
      resetButton(activeButton);
      activeButton = null;
    }
  }, true);

  document.addEventListener('atc:cart-added', function() {
    if (!activeButton) return;
    addConfirmed = true;
    clearTimeout(fallbackTimer);
    var btn = activeButton;
    setState(btn, 'added');
    clearTimeout(successTimer);
    successTimer = setTimeout(function() {
      resetButton(btn);
      if (activeButton === btn) activeButton = null;
    }, 1500);
  });

  document.addEventListener('atc:cart-error', function() {
    if (!activeButton) return;
    clearTimeout(fallbackTimer);
    clearTimeout(successTimer);
    resetButton(activeButton);
    activeButton = null;
  });
})();